import apiClient from "../api-services/ApiClient";
import { getErrorMessage } from ".";
import notify from "./notify";

/** Must match ADMIN_EXPORT_MAX_ROWS on the server (config/admin.php export_max_rows) */
export const EXPORT_MAX_ROWS = 50000;

/**
 * Downloads a full CSV export (every row matching the current filters, not just
 * the page on screen). Page and page-size params are dropped.
 * Returns true when the file was downloaded.
 */
export const downloadCsvExport = async (
  endpoint: string,
  params: Record<string, unknown>,
  fileBase: string,
  rowCount?: number,
  noun = "rows"
): Promise<boolean> => {
  if (rowCount !== undefined && rowCount > EXPORT_MAX_ROWS) {
    notify.error(
      `This export has ${rowCount.toLocaleString()} ${noun}; the limit is ${EXPORT_MAX_ROWS.toLocaleString()}. Narrow the filters (for example a date range) and try again.`
    );
    return false;
  }

  const { page, per_page, ...filters } = params;
  void page;
  void per_page;
  // drop empty filters so the file name and URL stay clean
  const clean = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== "" && v !== undefined && v !== null));

  try {
    const res: any = await apiClient.get(endpoint, { params: clean, responseType: "blob" });
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileBase}_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    notify.success(
      rowCount !== undefined ? `Exported ${rowCount.toLocaleString()} ${noun}.` : "Export downloaded."
    );
    return true;
  } catch (error) {
    notify.error(`Couldn't export: ${getErrorMessage(error)}`);
    return false;
  }
};
